import { Anchor, Paragraph } from '@zillow/constellation';
import { URLS } from '../../../../constants/urls';
import React from 'react';
import { useSelector } from 'react-redux';
import { isRoomForRentSelector } from '../../../../selectors';

function RestrictedBodyText() {
  const isRoomForRent = useSelector(isRoomForRentSelector);
  if (isRoomForRent) {
    return (
      <Paragraph>
        Based on your room for rent listing type, you are not able to receive applications through Zillow. For more
        information, please see <Anchor href={URLS.R4R_RESTRICTION_HELP}>this article</Anchor>.
      </Paragraph>
    );
  } else {
    // multi-family listing
    return (
      <Paragraph>
        Based on your contract agreement with Zillow, you are not able to receive applications through Zillow. If you
        believe you've received this message in error, please{' '}
        <Anchor href={URLS.NEW_ZENDESK_REQUEST}>contact support</Anchor>.
      </Paragraph>
    );
  }
}

export default RestrictedBodyText;
